export default async searchParam => {
  const URL = searchParam?.length
    ? `${__API_BASE__}/open/products?division=ELT&term=${searchParam}`
    : `${__API_BASE__}/open/products?division=ELT`;

  const resp = await fetch(URL);
  return resp.json();
};
